/* __next_internal_client_entry_do_not_use__ ServiceTabItem,Default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
// Global
import { useRef } from 'react';
import { tv } from 'tailwind-variants';
// Local
import { withStandardComponentWrapper } from 'helpers/HOC';
import { getTestProps } from 'lib/testing/utils';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { useTab } from 'helpers/Context/TabContext';
import { EditingHelpText } from 'helpers/Editing/EditingHelpText';
import useDictionary from 'lib/hooks/useDictionary';
import useIsEditing from 'lib/hooks/useIsEditing';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
const ServiceTabItem = (props)=>{
    const { DynamicPlaceholderId } = props?.params || {};
    const { uid } = props?.rendering || {};
    const { getDictionaryValue } = useDictionary();
    const TabId = `tab-content-${uid}`;
    const tabItemHeadlineRef = useRef(null);
    const { activeTab, tabs } = useTab();
    const isActive = props?.rendering?.uid === activeTab;
    const isEditing = useIsEditing();
    const hasMultipleItems = tabs.length > 1;
    const shouldShowTabs = hasMultipleItems || isEditing;
    const { base } = TAILWIND_VARIANTS({
        isActive
    });
    const phKey = `servicetabcard-${DynamicPlaceholderId}`;
    return (
        /*#__PURE__*/ _createElement("div", {
            "data-component": "authorable/shared/lists/ServiceTabItem",
            ...editingHydrationProps(isEditing),
            className: base({
                isActive
            }),
            key: TabId,
            ref: tabItemHeadlineRef,
            id: TabId,
            role: "tabpanel",
            "aria-live": "polite",
            ...(shouldShowTabs && {
                'aria-labelledby': `tab-${uid}`
            }),
            ...getTestProps(`component-tab-item-${TabId}`),
            children: [
                /*#__PURE__*/ _jsxs(EditingHelpText, {
                    children: [
                        "\uD83D\uDCA1 ",
                        /*#__PURE__*/ _jsxs("strong", {
                            children: [
                                getDictionaryValue('Tip') || 'Tip',
                                ":"
                            ]
                        }),
                        ' ',
                        getDictionaryValue('ServiceTabItemHelpText') || 'Drag another Service Tab Item above or below this one to add more services to the tabs'
                    ]
                }),
                /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                    name: phKey,
                    rendering: props.rendering,
                    ...getTestProps(`servicetabcard-ph-${props?.rendering?.uid}`)
                })
            ]
        })
    );
};
export { ServiceTabItem };
export const Default = withStandardComponentWrapper(ServiceTabItem);
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'flex',
            'flex-col',
            'gap-spacing-spacing-24',
            'grow'
        ]
    },
    variants: {
        isActive: {
            true: {
                base: [
                    'visible'
                ]
            },
            false: {
                base: [
                    'hidden'
                ]
            }
        }
    }
});
